<template>
  <div id="zhuanti">
    <van-cell v-for="(item, k) in lists" :key="k">
      <a :href="item.url">
        <div class="item">
          <img :src="item.poster" alt="" class="head-image" />
          <div class="title">{{ item.title }}</div>
          <div
            class="status"
            :class="{ active: item.status == 1 }"
            v-text="item.status == 1 ? '进行中' : '已结束'"
          ></div>
        </div>
      </a>
    </van-cell>
  </div>
</template>

<script>
import { loadAll } from '@/api/zhuanti'
export default {
  name: 'list',
  data() {
    return {
      lists: [],
      doing: false
    }
  },
  mounted() {
    this.doLoadAll()
  },
  methods: {
    doLoadAll() {
      if (this.doing) return false
      this.doing = true

      loadAll().then((res) => {
        if (res.code == 1) {
          this.lists = res.data
        } else {
          Toast.fail('加载失败')
        }
        this.doing = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
#zhuanti {
  .item {
    .title {
      color: #000;
    }
    .status {
      color: rgb(141, 145, 146);
    }
    .active {
      color: rgb(4, 190, 2);
    }
  }
  img {
    width: 100%;
  }
}
</style>
